const {LitElement, html, ref, createRef} = window.globalLit;
import BaseStepElement from './BaseStepElement.js';

customElements.define('navigate-step', class NavigateStepElemnt extends BaseStepElement {

    render() {
        return html`
            <strong>Navigate to </strong>
                <input is="autogrow-input" type="text" 
                    placeholder="URL..."
                    value="${this.value.url}"
                    ?readonly=${this.readonly}
                    @input="${this._onChange.bind(this, 'url')}"
                    style="min-width: 40px; width: 40px;"
                    class="step__input bg-primary-subtle text-primary">

        `;
    }
    
});